import M from 'materialize-css';



// Callback for Modal open. Modal and trigger parameters available.
function onModalOpen(modal, trigger) {
    //console.log(modal[0]);
    let space = modal.querySelector('.space');
    let link = modal.querySelector('.link');

    if (space && link && space.innerHTML !== '' && link.href !== '') {
        load_iframe(space.innerHTML, link.href);
    }
}

function onModalClose(modal, trigger) {
    let space = modal.querySelector('.space');
    let link = modal.querySelector('.link');

    if (space && link && space.innerHTML !== '' && link.href !== '') {
        M.toast({html: 'Devi salvare per rendere effettivi questi cambiamenti', displayLength: 120000});
    }
}

function load_iframe(id, link) {
    var space = document.getElementById(id);

    // No reload if the iframe exists yet
    var iframe = document.getElementById('iframe_' + id);
    if (iframe) {
        return;
    }

    // Create the iFrame
    var iframe = document.createElement("iframe");
    iframe.src = link;
    iframe.id = 'iframe_' + id;
    iframe.onload = function () {
        // Delete preloader
        var toDelete = document.getElementById('p_frame_modal_' + id.replace('frame_modal_', ''));
        if (toDelete != null)
            space.removeChild(toDelete);
        // Opacize iFrame
        this.style.display = 'block';
    };
    space.appendChild(iframe);
}

function initMaterializeModals(modals) {
    let arr = [];
    for (var i=0; i<modals.length; i++) {
        let dismissible= !modals[i].classList.contains('un-dismissible')
        let modal = M.Modal.init( modals[i],{
            dismissible: dismissible,
            onOpenEnd: onModalOpen,
            onCloseEnd: onModalClose
        });
        arr.push(modal);
    }
    return arr;
}

function initMaterializeComponents() {
    // Initialize collapse button
    let sidenavs = document.querySelectorAll('.sidenav');
    sidenavs.forEach( el => {
        let options = {
            edge: 'left',
            draggable: true,
            preventScrolling: true,
        };

        if (el.getAttribute('data-side')){
            options.edge = el.getAttribute('data-side');
        }
        M.Sidenav.init(el, options);
    });

    // Move navbar fixed of group-view to top bar
    let navBarFixed = document.querySelector('.navbar-fixed.moveOnTop');
    if (navBarFixed) {
        let main = document.querySelector('body > main');
        main.parentElement.insertBefore(navBarFixed, main);
    }


    // Initialize collapsible
    let collapsible = document.querySelectorAll('.collapsible');
    M.Collapsible.init(collapsible, {});

    // initialize tabs
    let tabs = document.querySelectorAll('ul.tabs');
    tabs.forEach( tabComponent => {
        M.Tabs.init(tabComponent, {});
    })

    // Initialize floating Action
    let floBut = document.querySelectorAll('.fixed-action-btn');
    M.FloatingActionButton.init(floBut, {});

    // Initialize materialize modal
    let modals = document.querySelectorAll('.modal');
    initMaterializeModals(modals);

    // Initialize materialize tooltip
    let tooltips = document.querySelectorAll('.tooltipped');
    M.Tooltip.init(tooltips, {"exitDelay": 10});

    let drops = document.querySelectorAll('.dropdown-trigger');
    M.Dropdown.init(drops, {
        alignment: 'none',
        constrainWidth: false,      // Does not change width of dropdown to that of the activator
        hover: false,               // Activate on hover
        inDuration: 300,
        outDuration: 225,
    });

    window.M = M;
    window.initMaterializeModals = initMaterializeModals;
}

export default initMaterializeComponents;
